import apiService from "../../services/apiService";
const PROFILE_ENDPOINT = "backend/profile";
export const getUserProfile = async () => {
  const response = await apiService.getAll(PROFILE_ENDPOINT);
  return response.data; // { status, data }
};
export const addUserProfile = async (body) => {
  const { data } = await apiService.create(PROFILE_ENDPOINT, body);
  return data; // returns backend response
};
export const updateUserProfile = async (formData) => {
  const { data } = await apiService.create(
    "backend/profile/update",
    formData
  );

  return data;
};
